const INSIDE_POPUP_SELECTORS = [
  '.usage-license-type-select',
  '.track__cart-link',
  '.track__action-button-add-to-cart',
  '.track__action-button-added-to-cart',
  '.sound-effect__cart-link',
  '.sound-effect__action-button-add-to-cart',
  '.sound-effect__action-button-added-to-cart',
  '.static-track__action-button-add-to-cart',
  '.static-track__action-button-added-to-cart',
  '.project-track__cart-button',
  '.cart',
  '.cart__drawer-shell',
  '.track-favorites',
  '.track-favorites__drawer-shell',
  '.track-favorites__action-button-add-to-cart',
  '.track-favorites__action-button-added-to-cart',
  '.search-tab',
  '.track__free-download',
  '.track__free-download-dialog-wrapper',
  '.checkbox-dropdown',
  '.dropdown'
]

function normalizeTarget(target) {
  if (!target) return null
  if (typeof target.closest === 'function') return target
  return target.parentElement || null
}

export function shouldClosePopupMenus(target) {
  const element = normalizeTarget(target)
  if (!element || typeof element.closest !== 'function') return true

  return !INSIDE_POPUP_SELECTORS.some((selector) => element.closest(selector))
}

export default shouldClosePopupMenus
